import { BrowserCacheLocation, Configuration, LogLevel } from '@azure/msal-browser';
import { environment } from '../environments/environment';

// B2C Policy
export const b2cPolicies = {
  names: {
    signUpSignIn: 'B2C_1A_SignIn',
    userProfile: 'B2C_1A_UserProfile'
  },
  authorities: {
    signUpSignIn: {
      authority: `${environment.baseAuthorityDomain}/B2C_1A_SignIn`
    },
    userProfile: {
      authority: `${environment.baseAuthorityDomain}/B2C_1A_UserProfile`
    }
  },
  authorityDomain: `${environment.authorityDomain}`
};

export const apiConfig: { b2cScopes: string[]; webApi: string } = {
  b2cScopes: [
    `${environment.b2cScopeBaseUrl}/${environment.apiClientId}/EDUAPI.write`,
    `${environment.b2cScopeBaseUrl}/${environment.apiClientId}/EDUAPI.read`,
    `${environment.b2cScopeBaseUrl}/${environment.apiClientId}/Authorisation.AppRoles.Own`
  ],
  webApi: environment.dataUploadApiEndpoint
};

export const tokenRequest: { scopes: string[] } = {
  scopes: apiConfig.b2cScopes
};

export const loginRequest = {
  scopes: apiConfig.b2cScopes
};

// MSAL Configuration
export const msalConfig: Configuration = {
  auth: {
    clientId: environment.clientId, // This is the ONLY mandatory field that you need to supply.
    authority: b2cPolicies.authorities.signUpSignIn.authority, // Defaults to "https://login.microsoftonline.com/common"
    knownAuthorities: [b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.
    redirectUri: '/redirect', // Points to window.location.origin. You must register this URI on Azure portal/App Registration.
    postLogoutRedirectUri: '/' // Indicates the page to navigate after logout.
  },
  cache: {
    cacheLocation: BrowserCacheLocation.SessionStorage // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
  },
  system: {
    allowPlatformBroker: false,
    loggerOptions: {
      logLevel: LogLevel.Verbose,
      piiLoggingEnabled: false
    }
  }
};
